import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "find-roof"
}
const _hoisted_2 = { class: "find-roof__address" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "find-roof__heading" }
const _hoisted_5 = { class: "find-roof__heading-text" }
const _hoisted_6 = { class: "find-roof__address-form" }
const _hoisted_7 = { class: "columns is-mobile" }
const _hoisted_8 = { class: "column" }
const _hoisted_9 = { class: "column is-narrow" }
const _hoisted_10 = {
  key: 1,
  class: "find-roof__heading"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "find-roof__heading-text" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  id: "address-tooltip-ref",
  class: "find-roof__tooltip-ref"
}, null, -1)
const _hoisted_14 = { class: "find-roof__content" }
const _hoisted_15 = { class: "find-roof__title h4" }
const _hoisted_16 = { class: "find-roof__reqs" }
const _hoisted_17 = ["data-testid"]
const _hoisted_18 = ["data-testid"]
const _hoisted_19 = ["data-testid"]
const _hoisted_20 = { class: "find-roof__buttons" }
const _hoisted_21 = { class: "find-roof__map" }
const _hoisted_22 = { class: "h4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputField = _resolveComponent("InputField")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_GMap = _resolveComponent("GMap")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Article = _resolveComponent("Article")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.pageContent)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(_component_Card, { "two-column-layout": "" }, {
          heading: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.showAddressForm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.pageContent.changeAddressFormTitle), 1),
                      _createElementVNode("a", {
                        href: "javascript:;",
                        class: "find-roof__heading-btn",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelAddressChange && _ctx.cancelAddressChange(...args)))
                      }, _toDisplayString(_ctx.pageContent.changeAddressCancelButtonCopy), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_InputField, {
                        modelValue: _ctx.addressForm.address,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addressForm.address) = $event)),
                        label: "First line of address",
                        name: "address",
                        class: "full-width"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_InputField, {
                            modelValue: _ctx.addressForm.postcode,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addressForm.postcode) = $event)),
                            name: "postcode",
                            label: "Postcode"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_AppButton, {
                            class: "find-roof__address-search",
                            "data-testid": "address-search-button",
                            loading: _ctx.isSearchingAddress,
                            disabled: !_ctx.addressFormModified,
                            onClick: _ctx.searchAddress
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.pageContent.changeAddressSearchButtonCopy), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["loading", "disabled", "onClick"])
                        ])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("img", {
                      src: require('@/assets/images/location.svg'),
                      class: "mr-2",
                      alt: "Address"
                    }, null, 8, _hoisted_11),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.getFullAddress), 1),
                    _createElementVNode("a", {
                      href: "javascript:;",
                      class: "find-roof__heading-btn",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleAddressForm && _ctx.toggleAddressForm(...args)))
                    }, _toDisplayString(_ctx.pageContent.changeAddressButtonCopy), 1)
                  ]))
            ]),
            _hoisted_13,
            (_ctx.addressTooltip === _ctx.TOOLTIP.SKIP_STEP)
              ? (_openBlock(), _createBlock(_component_Tooltip, {
                  key: 0,
                  "tooltip-content": _ctx.pageContent.addressNotFoundTooltipText2,
                  "got-it-button": _ctx.pageContent.addressNotFoundTooltipBtn2,
                  class: "find-roof__tooltip",
                  reference: "#address-tooltip-ref",
                  boundary: "#address-tooltip-ref",
                  onClose: _ctx.skipThisStep
                }, null, 8, ["tooltip-content", "got-it-button", "onClose"]))
              : _createCommentVNode("", true),
            (_ctx.addressTooltip === _ctx.TOOLTIP.TRY_AGAIN)
              ? (_openBlock(), _createBlock(_component_Tooltip, {
                  key: 1,
                  "tooltip-content": _ctx.pageContent.addressNotFoundTooltipText1,
                  "got-it-button": _ctx.pageContent.addressNotFoundTooltipBtn1,
                  class: "find-roof__tooltip",
                  reference: "#address-tooltip-ref",
                  boundary: "#address-tooltip-ref",
                  onClose: _ctx.toggleAddressForm
                }, null, 8, ["tooltip-content", "got-it-button", "onClose"]))
              : _createCommentVNode("", true)
          ]),
          rightColumn: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_GMap, {
                ref: "gmap",
                location: _ctx.markerLocation,
                address: _ctx.getFullAddress,
                class: "find-roof__map-inner",
                onMarkerChange: _ctx.onMapMarkerChange,
                onZoomChange: _ctx.onMapZoomChange,
                onMapDrag: _ctx.onMapDrag,
                onError: _ctx.onMapError,
                onAddressSearch: _ctx.onAddressSearch
              }, {
                mapError: _withCtx(() => [
                  _createVNode(_component_AppButton, {
                    class: "mt-5",
                    onClick: _ctx.skipThisStep
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.pageContent.addressNotFoundTooltipBtn2), 1)
                    ], undefined, true),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["location", "address", "onMarkerChange", "onZoomChange", "onMapDrag", "onError", "onAddressSearch"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h1", _hoisted_15, _toDisplayString(_ctx.pageContent.title), 1),
              _createElementVNode("ul", _hoisted_16, [
                _createElementVNode("li", {
                  ref: "req-zoom",
                  class: _normalizeClass(["find-roof__reqs-req", { 'find-roof__reqs-req--pass': _ctx.isMapZoomed }]),
                  "data-testid": 
              _ctx.isMapZoomed ? 'roof-requirement-met' : 'roof-requirement-unmet'
            
                }, _toDisplayString(_ctx.pageContent.zoomRequirementText), 11, _hoisted_17),
                _createElementVNode("li", {
                  ref: "req-map-centered",
                  class: _normalizeClass(["find-roof__reqs-req", { 'find-roof__reqs-req--pass': _ctx.isMapCentered }]),
                  "data-testid": 
              _ctx.isMapCentered ? 'roof-requirement-met' : 'roof-requirement-unmet'
            
                }, _toDisplayString(_ctx.pageContent.mapMoveRequirementText), 11, _hoisted_18),
                _createElementVNode("li", {
                  ref: "req-marker-set",
                  class: _normalizeClass(["find-roof__reqs-req", { 'find-roof__reqs-req--pass': _ctx.isMarkerSet }]),
                  "data-testid": 
              _ctx.isMarkerSet ? 'roof-requirement-met' : 'roof-requirement-unmet'
            
                }, _toDisplayString(_ctx.pageContent.markerRequirementText), 11, _hoisted_19)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_AppButton, {
                  class: "find-roof__buttons-next",
                  disabled: !_ctx.canGoToNextStep,
                  onClick: _ctx.goToNextStep
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.pageContent.nextStepButtonCopy), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createElementVNode("a", {
                  href: "javascript:void(0)",
                  class: "find-roof__buttons-noroof",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.showCantFindRoofModal = true), ["prevent"]))
                }, _toDisplayString(_ctx.pageContent.cantFindRoofButtonCopy), 1)
              ])
            ])
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_Modal, {
          class: "find-roof__modal",
          "is-modal-open": _ctx.showCantFindRoofModal,
          onCloseModal: _ctx.toggleCantFindRoofModal
        }, {
          header: _withCtx(() => [
            _createElementVNode("h4", _hoisted_22, _toDisplayString(_ctx.pageContent.cantFindRoofModalTitle), 1)
          ]),
          body: _withCtx(() => [
            _createVNode(_component_Article, {
              "text-content": _ctx.pageContent.cantFindRoofModalContent
            }, null, 8, ["text-content"])
          ]),
          cancelButton: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.pageContent.cantFindModalCloseButtonCopy), 1)
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_AppButton, {
              class: "modal__close-button",
              variant: "invertedPrimary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showCantFindRoofModal = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.pageContent.cantFindModalCloseButtonCopy), 1)
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_AppButton, {
              class: "modal__close-button",
              onClick: _ctx.skipThisStep
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.pageContent.cantFindModalConfirmButtonCopy), 1)
              ], undefined, true),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["is-modal-open", "onCloseModal"])
      ]))
    : _createCommentVNode("", true)
}